module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAgMAAAAPYzcHAAAADFBMVEUAAAAAfu4Afe0AfO2nynzaAAAAA3RSTlMASePizoNQAAAAMklEQVQI12NgIADY/oPABAZuMP0ATsPEidAPVsQN0oREsxGjGWb/BAaIvQ8QNBtx1gMAJ2Y029kegBwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/zdq-2@2x.png
// module id = T1as
// module chunks = 96